export const SMART_ID_LOGIN_TRANSACTION_PREFIX = "smart-id-login";
